module.exports = __webpack_public_path__ + "img/svg/arrow-down.67067819407821142c730f618abf8e13.svg";